module.exports = __webpack_public_path__ + "bf80bd7aef5d46f072172b02c9be963b.png";